import di from 'di';

import Acl from 'js-core/js/plugins/Acl';
import { Events as AuthEvents } from 'js-core/js/plugins/Authentication';

import UserRole from 'common/enums/UserRole';

import Permission from 'app/enums/Permission';

function loadRole(acl) {

    const auth = di.get('auth');
    const session = auth.getSession();

    if(session) {

        const user = session.getIdentity();
        acl.setActiveRole(user.role);

        if(user.role === UserRole.ADMIN || user.grower?.waterInsightsAccessible) {

            acl.allow(Permission.ROUTE_WATER_INSIGHTS);
        }
    }
}

export default function() {

    const acl = new Acl();

    const openRoutes = [
        Permission.ROUTE_OVERVIEW_PERIOD, Permission.ROUTE_COHORTS,
        Permission.ROUTE_SHIPS, Permission.ROUTE_USERS, Permission.ROUTE_ACTIONS_EDIT
    ];

    acl.role(UserRole.VIEWER, [Permission.ROUTE_OVERVIEW_PERIOD, Permission.ROUTE_COHORTS, Permission.ROUTE_PARCELS, Permission.ROUTE_SECTIONS]);
    acl.role(UserRole.GROWER, [...openRoutes, Permission.ROUTE_PARCELS, Permission.ROUTE_SECTIONS, Permission.MUTATE_PARCELS, Permission.MUTATE_SECTIONS]);
    acl.role(UserRole.ADMIN, [...openRoutes, Permission.ROUTE_GROWERS, Permission.ROUTE_COHORT_DETAIL, Permission.MUTATE_PARCELS, Permission.MUTATE_SECTIONS]);

    loadRole(acl);

    const auth = di.get('auth');
    auth.on(AuthEvents.LOGIN, () => loadRole(acl));
    auth.on(AuthEvents.LOGOUT, () => acl.clearPermissions());

    di.set('acl', acl);
}
